import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import {
  fetchAllUsersResponse,
  showUserMessage,
  addAdminUserResponse,
  addAdminUserError,
  editAdminUserResponse,
  editAdminUserError,
  fetchAllPermissionsError,
  fetchAllPermissionsResponse,
  fetchPermissionsByUserIdResponse,
  fetchPermissionsByUserIdError,
} from "actions";
import api from "services/api";
import {
  ADD_ADMIN_USER,
  EDIT_ADMIN_USER,
  FETCH_ALL_PERMISSIONS,
  FETCH_ALL_USERS,
  FETCH_PERMISSIONS_BY_USERID,
} from "constants/ActionTypes";

const fetchAllUsersRequest = function*() {
  try {
    const fetchedUsers = yield call(api.get, `api/AdminRole/GetUserAsync`);
    // debugger
    yield put(fetchAllUsersResponse(fetchedUsers));
  } catch (error) {
    // console.error('error', error)
    yield put(showUserMessage(error));
  }
};

const addAdminUserRequest = function*({ payload }) {
  try {
    // debugger
    const newAdminUser = yield call(
      api.post, "api/Admin/CreateUserAsync", payload
    );
    yield put(addAdminUserResponse(newAdminUser));
  } catch (error) {
    yield put(addAdminUserError("An error occurred in adding admin user"));
  }
};
const editAdminUserRequest = function*({ payload }) {
  // debugger
  try {
    const editedAdminUser = yield call(
      api.post,"/api/Admin/CreateUserAsync", payload
    );
    // debugger
    yield put(editAdminUserResponse(editedAdminUser));
  } catch (error) {
    yield put(editAdminUserError("An error occurred in updating admin user"));
  }
};

const fetchAllPermissionsRequest = function*() {
    try {
        const fetchedPermissions = yield call(api.get, 'api/AdminRole/GetPermissionAsync')
        yield put(fetchAllPermissionsResponse(fetchedPermissions))
    } catch(error) {
        yield(fetchAllPermissionsError)
    }
}

const fetchPermissionsByUserIdRequest = function*({payload}) {
    try {
        // debugger
        const fetchedPermissions = yield call(api.get, `api/AdminRole/GetRolesIDAsync/${payload}`)
        // debugger
        yield put(fetchPermissionsByUserIdResponse(fetchedPermissions))
    } catch(error) {
      console.error({error})
        yield(fetchPermissionsByUserIdError)
    }
}


export const addAdminUser = function*() {
  yield takeEvery(ADD_ADMIN_USER, addAdminUserRequest);
};
export const editAdminUser = function*() {
  yield takeEvery(EDIT_ADMIN_USER, editAdminUserRequest);
};

export const fetchAllUsers = function*() {
  yield takeEvery(FETCH_ALL_USERS, fetchAllUsersRequest);
};

export const fetchPermissionsByUserId = function*() {
  yield takeEvery(FETCH_PERMISSIONS_BY_USERID, fetchPermissionsByUserIdRequest);
};


export const fetchAllPermissions = function*() {
    yield takeEvery(FETCH_ALL_PERMISSIONS, fetchAllPermissionsRequest)
}
const rootSaga = function*() {
  yield all([
    fork(fetchAllUsers),
    fork(addAdminUser),
    fork(editAdminUser),
    fork(fetchPermissionsByUserId)
  ]);
};

export default rootSaga;
